import { render } from "./FolderPicker.vue?vue&type=template&id=2f4d9ed6&ts=true"
import script from "./FolderPicker.vue?vue&type=script&lang=ts"
export * from "./FolderPicker.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./FolderPicker.vue?vue&type=style&index=0&id=2f4d9ed6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__